import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import useCustomerInfo from "@repo/shopify/hooks/useCustomerInfo";
import useCustomerInfoCaa from "@repo/shopify/hooks/useCustomerInfoCaa";
import useCustomerQueryCaa from "@repo/shopify/queries/useCustomerQueryCaa";
import { extractId } from "@repo/shopify/utils/common";

import { URLS } from "@const/urls";

import useCustomerQuery from "@hooks/useCustomerQuery";
import useLanguage from "@hooks/useLanguage";

import apolloCaaClient from "@lib/apolloCaa";

import { useCustomerStore } from "@store/customer";

export default function useAddresses() {
  const navigate = useNavigate();

  const { lang } = useLanguage();

  const { customer, token, caaCustomer, updateCaa } = useCustomerStore();

  const { fetchCustomer } = useCustomerQuery();
  const { fetchCaaCustomer } = useCustomerQueryCaa({ client: apolloCaaClient });

  const { isPartnership, addresses } = useCustomerInfo(customer, "thisisneverthat");
  const { addresses: caaAddresses } = useCustomerInfoCaa(caaCustomer ?? { id: "", tags: [] }, "thisisneverthat");

  const isJp = lang === "jp";

  useEffect(() => {
    if (isJp) {
      if (!caaCustomer) navigate(URLS.HOME);
      return;
    }

    if (!customer || isPartnership) navigate(URLS.HOME);
  }, [isJp, customer, isPartnership, caaCustomer, navigate]);

  const onCompletedMutation = async () => {
    if (isJp) {
      const { data } = await fetchCaaCustomer();
      if (data?.customer) updateCaa(data.customer);
      return;
    }

    await fetchCustomer({ variables: { customerAccessToken: token.accessToken } });
  };

  const defaultAddress = isJp ? caaCustomer?.defaultAddress : customer.defaultAddress;

  const otherAddresses = (isJp ? caaAddresses : addresses).filter((node) => extractId(node.id) !== extractId(String(defaultAddress?.id)));

  return {
    onCompletedMutation,
    defaultAddress,
    otherAddresses,
  };
}
